'use client';

import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';

const HomePagePopup = dynamic(() => import('@/components/otherpages/HomepagePopup'), { ssr: false });

interface HomePageClientProps {
  children: React.ReactNode;
}

const HomePageClient: React.FC<HomePageClientProps> = ({ children }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    // Only run on client — avoids any SSR/client mismatch
    const alreadyShown = sessionStorage.getItem('popupShown');
    if (alreadyShown) return;

    // Opens when the "Why teams love Working With Us" section scrolls into view, instead of
    // on a flat timer — so it shows up in response to how far the visitor has actually scrolled.
    const target = document.getElementById('why-teams-love-us');
    if (!target) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsPopupOpen(true);
          sessionStorage.setItem('popupShown', 'true');
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    observer.observe(target);

    return () => observer.disconnect();
  }, []);

  const handleFormSubmit = (formData: any) => {
    setIsPopupOpen(false);
    sessionStorage.setItem('popupShown', 'true');
  };

  return (
    <>
      {children}
      <HomePagePopup
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
        onSubmit={handleFormSubmit}
      />
    </>
  );
};

export default HomePageClient;